import http from "../../backend/http.js";

async function getAgreement(id) {
  try {
    const response = await http.get(`crm/agreements/${id}`);
    response.data.contacts.forEach(i => {
      i.title = `${i.surname} ${i.name} ${i.middlename}`;
    });

    return {
      id: response.data.id,
      title: response.data.title,
      description: response.data.description,
      amount: response.data.amount,
      owner: response.data.owner,
      company: response.data.company,
      currency: response.data.currency,
      salesFunnelType: response.data.salesFunnelType,
      salesFunnelStage: response.data.salesFunnelStage,
      contacts: response.data.contacts,
      tasks: response.data.tasks,
    };
  } catch (err) {
    throw err;
  }
}

async function updateAgreement(id, data) {
  try {
    const response = await http.put(`crm/agreements/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createAgreement(data) {
  try {
    const response = await http.post("crm/agreements", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getAgreements(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/agreements?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectAgreements(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/agreements/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getAgreement, updateAgreement, getAgreements, createAgreement, selectAgreements };